import { Component,Input,OnChanges,OnInit } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';
import { HrDashboardService, MonthlyOverview } from '../../../services/hr-dashboard.service';

@Component({
  selector: 'app-monthly-overview-widget',
  standalone: false,
  templateUrl: './monthly-overview-widget.component.html',
  styleUrl: './monthly-overview-widget.component.scss'
})

export class MonthlyOverviewWidgetComponent implements OnChanges {

  months: string[] = [];
  selectedMonth = '';
  performanceTrend: any[] = [];
  @Input() tenantId!: number;

  //  FIX: Full Color object
  colorScheme: Color = {
    name: 'monthlyScheme',
    selectable: true,
    group: ScaleType.Ordinal,
    domain: ['#2F80ED']
  };

 constructor(private hrDashboardService: HrDashboardService) {}

  ngOnChanges(): void {
    if (this.tenantId) {
    this.loadMonthlyOverview();
  }
}

  loadMonthlyOverview() {

    this.hrDashboardService.getMonthlyOverview('tenant', this.tenantId).subscribe({

      next: (data: MonthlyOverview[]) => {
        
        const monthsOrder = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
        const ordered = data.sort((a, b) => {
          const [am, ay] = a.month.split(' ');
          const [bm, by] = b.month.split(' ');
          return parseInt(ay) - parseInt(by) || monthsOrder.indexOf(am) - monthsOrder.indexOf(bm);
        });

        this.months = ordered.map(d => d.month);
        this.selectedMonth = this.months[0];

        this.performanceTrend = [
          {
            name: 'Performance',
            series: ordered.map(d => ({
              name: d.month,
              value: d.totalScore
            }))
          }
        ];
      },
      error: (err) => console.error('Error fetching monthly overview:', err)
    });
  }
}
